import { getRequestGateway } from './api.service'
import { UserMessage } from '@/interfaces/userMessage.interface'

export const getUserMessage = async (): Promise<UserMessage[]> => {
  try {
    const res = await getRequestGateway<UserMessage[]>('/user-communication/current-messages')
    return res.data
  } catch (error) {
    console.error('Error fetching data', error)
    throw error
  }
}
